import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as ruptureActions from 'action/rupture'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import Rupture from 'component/report/rupture/PreviousDayRupture'
import RuptureHeader from 'component/report/rupture/RuptureHeader'
import BranchFilterRupture from 'component/report/rupture/BranchFilterRupture'
import FeedbackError from 'component/utils/FeedbackError'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class PreviousDayRuptureContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchRuptures: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    rupture: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
    user:PropTypes.object
   
  }

  constructor(props) {
    super(props)

    this.state = {
      ruptureInfoVisible: false,
      missionsSelectBranchs: []
    }

    this.getCsv = this.getCsv.bind(this)
    this.getPdf = this.getPdf.bind(this)
  }

  componentWillMount() {
    const { fetchRuptures, auth } = this.props
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }

    this.getParameter(params).then(resp => {
      const missions = resp.data.split(",") || []
      this.setState({missionsSelectBranchs: missions})
      if (auth.user.locationCode !== '999' ) {
        
        if(!missions.includes(auth.user.title)) {
          
          fetchRuptures(auth)
        } 
      }

    }).catch(() => {
      if (auth.user.locationCode !== '999') {
        fetchRuptures(auth)
      }
    })
    
  }

  getParameter(values) {
    const { auth: { user } } = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    
  }


  handleFetchRuptures = (values) => {
    const { fetchRuptures, auth } = this.props

    fetchRuptures(auth, values)
    
    this.setState({ ruptureInfoVisible: true })
  }

  getCsv() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 0,
    }

    fetchReports(user.dsToken, values, filters)
  }

  getPdf() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 1,
    }

    fetchReports(user.dsToken, values, filters)
  }

  renderError(message) {
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  render() {
    const { translate, error, rupture, filters, auth } = this.props

    const { ruptureInfoVisible } = this.state

    return (
      <section>
        <ContentHeader>{translate('previousDayRuptures.title')}</ContentHeader>

        <RuptureHeader
          translate={translate}
          currentTitle={translate('previousDayRuptures.title')}
        />

        {!ruptureInfoVisible && (
          <BranchFilterRupture
            translate={translate}
            missionsSelectBranchs={this.state.missionsSelectBranchs || []}
            fetchRuptures={this.handleFetchRuptures}
            auth={auth}
          />
        )}

        {error && this.renderError(error.message)}

        {ruptureInfoVisible && (
          <Rupture
            translate={translate}
            rupture={rupture}
            getCsv={this.getCsv}
            getPdf={this.getPdf}
            filters={filters}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = ({ ruptureReducer, reportReducer }) => ({
  rupture: ruptureReducer.record,
  error: ruptureReducer.error,
  filters: ruptureReducer.filters,
  report: reportReducer.get.record,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...ruptureActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const RuptureTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PreviousDayRuptureContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(mapStateToProps, mapDispatchToProps)(RuptureTranslated)

export { PreviousDayRuptureContainer }
